import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  prefixStyle: {
    color:
      theme?.palette?.card?.cardFontColor || theme.palette.common.fontTitle,
    minWidth: '60px',
    '& .MuiSelect-select': {
      paddingRight: '24px !important',
    },
    '& .MuiSelect-icon': {
      right: '4px',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
  },
}));

export default useStyles; 